import React from "react";
import { Navigate, Outlet } from "react-router-dom";

import { Pathname } from "../constants/pathnames/pathname";
import { useAuth } from '@erpsquad/common/runtime';
import Loader from "../components/loader";

export const PrivateRoute = () => {
  const { user, loading } = useAuth();

  return loading ? (
    <Loader />
  ) : user ? (
    <Outlet />
  ) : (
    <Navigate to={Pathname.LOGIN} />
  );
};

export default PrivateRoute;
